(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-b-personalize-teaser"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-vb-teaser]').forEach((root) => {
      const productJsonEl = root.querySelector('[data-vb-product-json]');
      const optionsJsonEl = root.querySelector('[data-vb-options-json]');
      if (!productJsonEl || !optionsJsonEl) return;

      const swatchImagesEl = root.querySelector('[data-vb-swatch-images]');
      let variants = [];
      let options = [];
      let swatchImages = {};
      try {
        variants = JSON.parse(productJsonEl.textContent);
        options = JSON.parse(optionsJsonEl.textContent);
        if (swatchImagesEl) swatchImages = JSON.parse(swatchImagesEl.textContent);
      } catch (e) {
        return;
      }

      const cloudOptionName = root.dataset.vbCloudOption;
      const embOptionName = root.dataset.vbEmbOption;
      const productUrl = root.dataset.vbProductUrl;

      const cloudOption = options.find((o) => o.name === cloudOptionName);
      const embOption = options.find((o) => o.name === embOptionName);

 const embColorFallback = {
  Bruin: '#70452F',
  'Warm Goud': '#C9A15F',
  Roze: '#D79AAA',
  Blauw: '#8FBAD2',
  Wit: '#FFFFFF',
};

      const cloudPosition = Number(cloudOption?.position || (options.indexOf(cloudOption) + 1));
      const embPosition = Number(embOption?.position || (options.indexOf(embOption) + 1));
      const state = { cloud: null, emb: null, name: '' };

      function optionAt(variant, position) {
        if (!position || position < 1 || position > 3) return null;
        return variant[`option${position}`];
      }

      function combinationExists(cloud, emb) {
        return variants.some((v) => {
          const matchesCloud = !cloudOption || optionAt(v, cloudPosition) === cloud;
          const matchesEmb = !embOption || optionAt(v, embPosition) === emb;
          return matchesCloud && matchesEmb;
        });
      }

      function refreshEmbroideryAvailability({ clearInvalidSelection = false } = {}) {
        const embContainer = root.querySelector('[data-vb-teaser-emb]');
        if (!embContainer || !embOption) return;

        embContainer.querySelectorAll('.vb-swatch').forEach((btn) => {
          const valid = !state.cloud || combinationExists(state.cloud, btn.dataset.value);
          btn.classList.toggle('is-unavailable', !valid);
          btn.disabled = !valid;
          btn.setAttribute('aria-disabled', valid ? 'false' : 'true');
        });

        if (clearInvalidSelection && state.emb && !combinationExists(state.cloud, state.emb)) {
          state.emb = null;
          embContainer.querySelectorAll('.vb-swatch').forEach((btn) => btn.classList.remove('is-selected'));
        }
      }

      function renderRow(container, option, kind) {
        if (!option || !container) return;
        container.innerHTML = '';
        option.values.forEach((value) => {
          const name = value.name || value.value || value;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vb-swatch';
          btn.dataset.value = name;
          const dot = document.createElement('span');
          dot.className = 'vb-swatch__dot';
         if (kind === 'emb') {
  dot.style.backgroundImage = 'none';
  dot.style.backgroundColor = embColorFallback[name] || '#D9D1C7';
} else if (swatchImages[name]) {
  dot.style.backgroundImage = `url('${swatchImages[name]}')`;
}
          const label = document.createElement('span');
          label.className = 'vb-swatch__name';
          label.textContent = name;
          btn.appendChild(dot);
          btn.appendChild(label);
          btn.addEventListener('click', () => {
            if (btn.disabled) return;
            state[kind] = name;
            container.querySelectorAll('.vb-swatch').forEach((s) => s.classList.remove('is-selected'));
            btn.classList.add('is-selected');

            if (kind === 'cloud') {
              refreshEmbroideryAvailability({ clearInvalidSelection: true });
            }
            updateHeadingAndLink();
          });
          container.appendChild(btn);
        });

        // Select a sensible initial value. On later cloud changes, invalid
        // embroidery choices are intentionally cleared so the customer must
        // make a new, valid choice.
        const first = container.querySelector('.vb-swatch:not(:disabled)');
        if (first) {
          first.classList.add('is-selected');
          state[kind] = first.dataset.value;
        }
      }

      function findVariant() {
        if (!variants.length) return null;
        return variants.find((v) => {
          const matchesCloud = !cloudOption || optionAt(v, cloudPosition) === state.cloud;
          const matchesEmb = !embOption || optionAt(v, embPosition) === state.emb;
          return matchesCloud && matchesEmb;
        });
      }

      function updateHeadingAndLink() {
        const heading = root.querySelector('[data-vb-teaser-heading]');
        if (heading) {
          heading.textContent = state.name ? `Voor ${state.name}` : 'Voor wie mogen we hem maken?';
        }
        const cta = root.querySelector('[data-vb-teaser-cta]');
        if (cta && productUrl) {
          const variant = findVariant();
          const params = new URLSearchParams();
          if (variant) params.set('variant', variant.id);
          if (state.name) params.set('vb_name', state.name);
          const query = params.toString();
          cta.href = query ? `${productUrl}?${query}` : productUrl;
        }
      }

      const nameInput = root.querySelector('[data-vb-teaser-name]');
      if (nameInput) {
        nameInput.addEventListener('input', (e) => {
          state.name = e.target.value;
          updateHeadingAndLink();
        });
      }

      renderRow(root.querySelector('[data-vb-teaser-cloud]'), cloudOption, 'cloud');
      renderRow(root.querySelector('[data-vb-teaser-emb]'), embOption, 'emb');
      refreshEmbroideryAvailability({ clearInvalidSelection: true });
      updateHeadingAndLink();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-b-tap-moment"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-vb-tap-media]').forEach((media) => {
      let tapped = false;
      media.addEventListener('click', () => {
        if (tapped) return;
        tapped = true;
        const video = media.querySelector('video');
        const ring = media.querySelector('[data-vb-tap-ring]');
        const text = media.querySelector('[data-vb-tap-text]');
        const afterLabel = media.dataset.vbAfterLabel || 'Daar begint de avond.';
        media.classList.add('is-lit');
        if (ring) ring.classList.add('is-hidden');
        if (video) video.play().catch(() => {});
        if (text) {
          text.style.opacity = '0';
          setTimeout(() => {
            text.textContent = afterLabel;
            text.style.opacity = '1';
          }, 500);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
